import React, { Component } from 'react';
import _ from 'lodash';
import shared from '../../../utils/shared.js';

class FamilyStory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      background: null
    }
  }

  componentDidMount() {
    this.setupStory();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setupStory();
    }
  }

  setupStory = () => {
    let backgroundImage = null;
    let backgroundObj = _.get(this.props.story, 'contents.images[0]', null);

    if (backgroundObj) {
      backgroundImage = this.getBackground(backgroundObj);
    }

    this.setState({
      background: backgroundImage
    });
  }

  getBackground = (displayImage) => {
    if (displayImage) {
      return shared.dp(this.props.screen, displayImage, null);
    }
    return null;
  }

  render() {
    let type = _.get(this.props.story, 'contents.custom_fields.story_type.val.value', null);
    if (!type || type !== 'family_story') {
      return (<span/>);
    }
    // let backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    if (this.state.background === undefined || this.state.background === null) {
      return (<span/>);
    }
    return (
      <div style={{ position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, top: -this.props.screen.r16_9.p10  }}>
        <img src={this.state.background} style={{ maxHeight: this.props.screen.screenHeight, maxWidth: this.props.screen.screenWidth, position:"absolute", bottom: 0 }} alt=""/>
      </div>
    );
  }
}

export default FamilyStory;


// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/FamilyStory.js